/** Example questions shown as one-tap buttons (spec: they start the conversation). */
export const OWNER_SUGGESTIONS = ['Что у меня завтра?', 'Сколько машин было на неделе?', 'Сколько денег получено?'] as const;

/**
 * Client questions. The price question names this studio's own main service: not every
 * studio does polishing, and a question about a service it lacks is a poor first tap.
 */
export function clientSuggestions(services: readonly { name: string; isFeatured: boolean }[]): string[] {
  const main = services.find((s) => s.isFeatured) ?? services[0];
  const price = main ? `Сколько стоит ${lowerFirst(main.name)}?` : 'Какие у вас цены?';
  return ['Когда ближайшее окно?', price, 'Как найти студию?'];
}

// «Химчистка салона» → «химчистка салона»; abbreviations («ПТС», «R17») stay as they are.
function lowerFirst(name: string) {
  return /^\p{Lu}\p{Ll}/u.test(name) ? name.charAt(0).toLocaleLowerCase('ru') + name.slice(1) : name;
}
